import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { observable, of, Observable } from "rxjs";
import { map, mergeMap, catchError, delay} from "rxjs/operators";

import { ClientService } from '@core/services/client/client.service';
import * as clientfileActions from "../state/clientfile.actions";
import { Client, ClientFileInfoModel } from '@core/services/client/client.model';


@Injectable()
export class ClientFileEffect{
    constructor(
        private actions$: Actions,
        private clientService: ClientService
    ){}

 

     /* -update Client File- */

    @Effect()
    updateClientFile$: Observable<Action> = this.actions$.pipe(
      ofType<clientfileActions.UPDATECLIENTFILE>(
        clientfileActions.ClientFileActionTypes.UPDATE_CLIENTFILE
      ),
      map((action: clientfileActions.UPDATECLIENTFILE) => action.payload),
      mergeMap((clientfile: ClientFileInfoModel) =>
        this.clientService.createOrUpdateClientFileInfo(clientfile).pipe(
          map(
            (updateClientFile: ClientFileInfoModel) =>
              new clientfileActions.UPDATECLIENTFILESUCCESS({
                id: updateClientFile.id,
                changes: updateClientFile
              })
          ),
          catchError(err => of(new clientfileActions.UPDATECLIENTFILEFAIL(err)))
        )
      )
    );
}
